<template>
  <div class="col-12 p-0 mb-2 d-flex justify-content-between">
    <small>{{ user.name }}</small>
  </div>
</template>

<script>
import Axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: {
    user: {
      required: true
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "getCurrentUser"
    })
  },
  methods: {
    deletePost: function () {
      Axios.post(`/post/delete`, {
        post: this.postID,
      })
        .then( () => {
          this.$emit('reloadPosts')
        })
    }
  }
}
</script>
